export default {
    "pcs": "PCS",
    "set": "Set",
    "combo": "Combo",
}
